export default __webpack_public_path__ + "static/media/Nikunj.2d158529.jpg";